export const METRIC_VARIANTS = [
    { id: 'big-number', label: 'Big Number', icon: 'fas fa-text-height' },
    { id: 'icon-leading', label: 'Icon + Number', icon: 'fas fa-icons' },
    { id: 'with-trend', label: 'Number + Trend', icon: 'fas fa-arrow-trend-up' },
    { id: 'gradient-card', label: 'Gradient Card', icon: 'fas fa-fill-drip' },
    { id: 'pill-badge', label: 'Pill Badge', icon: 'fas fa-capsules' },
    { id: 'bordered-box', label: 'Bordered Box', icon: 'fas fa-square' },
    { id: 'minimal', label: 'Minimal', icon: 'fas fa-minus' },
    { id: 'label-top', label: 'Caption + Number', icon: 'fas fa-heading' },
    { id: 'split-unit', label: 'Inline Unit', icon: 'fas fa-ruler' },
    { id: 'ring-accent', label: 'Ring Accent', icon: 'fas fa-dot-circle' },
];
